const state = {
  organizations: [],
  organization: {},
  organizationLogo: null,
  organizationMobileLogo: null,
  organizationStructure: null,
  accounts: [],
  organizationCategories: [],
  organizationSituationTypes: [],
  organizationCountryCodes: [],
}

export default state
